import { Link } from 'react-router-dom'
import CustomGraphy from '@/components/CustomGraphy'
import { PATHS } from '../paths'

export const MESSAGES = {
  asyncFileGeneration: (
    <CustomGraphy>
      Gerando arquivo, por favor aguarde. Acesse a seção de arquivos para baixá-lo.{' '}
      <Link to={PATHS.files.index}>Acessar agora</Link>
    </CustomGraphy>
  ),
  uploadError: 'Erro ao fazer upload do arquivo. Tente novamente.',
  generateUrlError: 'Erro ao gerar URL do arquivo. Tente novamente.',
  observationPhotoMaxLengthError: 'Observação não pode ter mais de 250 caracteres.',
  permissionError: 'Sem permissão para realizar esta ação.'
}
